import React from 'react';
import moment from 'moment';
import 'moment/locale/sl';
import { Link } from 'gatsby';
import styles from './Feed.module.scss';

moment.locale('sl');

const Feed = ({ edges }) => (
  <div className={styles['feed']}>
    {edges.map((edge) => (
      <div className={styles['feed__item']} key={edge.node.slug}>
        <div className={styles['feed__item-meta']}>
          <time className={styles['feed__item-meta-time']} dateTime={moment(edge.node.publishDate).format('MMMM D, YYYY')}>
            {moment(edge.node.publishDate).format('MMMM YYYY')}
          </time>
          <span className={styles['feed__item-meta-divider']} />
          <span className={styles['feed__item-meta-category']}>
            <Link to={edge.node.fields.categorySlug} className={styles['feed__item-meta-category-link']}>{edge.node.category}</Link>
          </span>
        </div>
        <h2 className={styles['feed__item-title']}>
          <Link className={styles['feed__item-title-link']} to={"post/" + edge.node.slug}>{edge.node.title}</Link>
        </h2>
        <p className={styles['feed__item-description']}>{edge.node.description.description}</p>
        <Link className={styles['feed__item-readmore']} to={"post/" + edge.node.slug}>Read</Link>
      </div>
    ))}
  </div>
);

export default Feed;
